
	import { defineComponent, ref } from "vue";
	import LikertModal from "@/components/LikertSurvey.vue";
	import PatientForm from "@/components/PatientForm.vue";
	import MeasurementScheduleList from "@/components/MeasurementScheduleList.vue";
	import ThermIcon from "@/assets/ThermIcon.vue";
	import SmileIcon from "@/assets/SmileIcon.vue";
	import HelpCircleIcon from "@/assets/HelpCircleIcon.vue";
	import BookIcon from "@/assets/BookIcon.vue";
	import BookOpenIcon from "@/assets/BookOpenIcon.vue";
	// import MenuCard from "@/components/MenuCard.vue";
	import { useRouter } from "vue-router";
	import useUser from "@/store/UserState";

	export default defineComponent({
		name: "dashboard-patient",
		components: {
			LikertModal,
			PatientForm,
			ThermIcon,
			HelpCircleIcon,
			SmileIcon,
			BookIcon,
			BookOpenIcon,
			MeasurementScheduleList,
			// MenuCard,
		},
		setup() {
			const router = useRouter();
			const { user } = useUser();

			const likertSurvey = ref(null);

			function onActionClick(ev: Event): void {
				console.log("actionClick", ev);
				switch ((ev.currentTarget as HTMLElement).id) {
					case "action-view-measures":
						router.push({
							name: "measurements",
						});
						break;
					case "action-view-diary":
						router.push({
							name: "diaries",
						});
						break;
					case "action-faqs":
						router.push({
							name: "faq",
						});
						break;
					case "action-how-to-use":
						router.push({
							name: "manual",
						});
						break;
					case "action-do-likert":
						(likertSurvey.value! as typeof LikertModal).open();
						break;
				}
			}
			return {
				user,
				likertSurvey,
				onActionClick,
			};
		},
	});
